import { IModule } from '@monorepo/application_module'
import { AuthProvider as Provider } from './auth_provider'

export * from './components'
export { useAuthenticatation } from './auth_provider'

export default { Provider } as IModule
